import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import BasicLayout from 'components/BasicLayout';
import TripCard, { ShimmerTripCard } from 'components/TripCard';
import TravelDetailsContainer from 'containers/TravelDetails';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelDetails } from 'models/travelDetails';

import RequestStatusInfo from '../../components/RequestStatusInfo';

function getItineraryId(travelDetails?: TravelDetails) {
  return travelDetails
    ? travelDetails.air
      ? travelDetails.air.orderNumber
      : travelDetails.vehicle
      ? travelDetails.vehicle.orderNumber
      : travelDetails.hotel?.orderNumber
    : '';
}

const TripSupport = () => {
  const { t } = useStoreTranslation();
  const { id } = useParams<{ id: string }>();

  const [detailsOpen, setDetailsOpen] = useState(false);

  return (
    <TravelDetailsContainer
      travelId={id}
      render={(loading, travelDetails) => (
        <BasicLayout
          title={t('customerSupport.title')}
          subtitle={t('customerSupport.tripSubtitle', { itineraryId: getItineraryId(travelDetails) })}
        >
          {!loading && !!travelDetails ? (
            <TripCard
              travel={travelDetails}
              onToggle={(status) => {
                setDetailsOpen(status);
              }}
              detailsOpen={detailsOpen}
              render={(_, expirationTime, isExpiring, isAir) => (
                <RequestStatusInfo
                  travelId={id}
                  status={travelDetails.requester.status}
                  travelDetails={travelDetails}
                  expirationTime={expirationTime}
                  isExpiring={isExpiring}
                  isAir={isAir}
                />
              )}
            />
          ) : (
            <ShimmerTripCard />
          )}
        </BasicLayout>
      )}
    />
  );
};

export default TripSupport;
